import React from 'react';
import type { RequestOptions } from 'searchkit';

import { SearchkitWrapper } from '@uncinc/react-searchkit';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../../config/constants';
import type { MetaParagraphsContentTypes } from '../../../types/uncinc_profile/paragraphs';
import { resultAttributes } from '../../SearchAllContent/config';
import { facetAttributes, sorting } from './config';

// Subcomponents.
import Inner from './Inner';

interface Subcomponents {
  Inner: typeof Inner;
}

export interface MetaSearchProps {
  requestOptions: RequestOptions;
  contentType: MetaParagraphsContentTypes;
  sortingList?: number[];
  hitsPerPage: number;
  withFacets?: boolean;
  withPagination?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const MetaSearch: React.FC<MetaSearchProps> & Subcomponents = ({
  requestOptions,
  contentType,
  sortingList = undefined,
  hitsPerPage,
  withFacets = false,
  withPagination = false,
  children,
  className,
}) => (
  <SearchkitWrapper
    className={className}
    connection={{
      host: SEARCHKIT_HOST_URL,
    }}
    indexName={APP_OPTIONS?.parameters.searchkitIndexAllContent}
    routing={false}
    hitsPerPage={hitsPerPage}
    requestOptions={requestOptions}
    searchSettings={{
      search_attributes: [],
      result_attributes: resultAttributes,
      facet_attributes: facetAttributes,
      sorting,
    }}
  >
    {children || (
      <Inner
        sortingList={sortingList}
        withFacets={withFacets}
        withPagination={withPagination}
      />
    )}
  </SearchkitWrapper>
);

MetaSearch.Inner = Inner;

export default MetaSearch;
